module.exports = __webpack_public_path__ + "media/components/Influencers/Messages/Shared/left-12a3acf267f21994e9b6e230ceb54ce6.png";